import { browser } from '../../../common/services/browser';
import { AngularServices, getAngularService } from '../helpers';
export const hideSidebarIfMobile = () => {
    if (browser.isMobileScreen()) {
        getAngularService(AngularServices.GlobalUi).toggleSidebar(true);
    }
};
